export const LANGUAGE = {
  FRENCH: 'fr',
  ENGLISH: 'en',
};

export const URL_LANGUAGE = LANGUAGE.ENGLISH;
